import type { ReactNode } from 'react'
import LanguageSelector from '@/components/layout/language-menu/LanguageSelector'
import { FlexContainer } from '../../..'
import * as styles from './HeaderSplitContent.styles'

interface Props {
  logo: ReactNode
}

const HeaderSplitContent = ({ logo }: Props) => (
  <FlexContainer
    align="center"
    css={[styles.headerSplitContent]}
    justify="space-between"
  >
    {logo}

    <div>
      <LanguageSelector />
    </div>
  </FlexContainer>
)

export default HeaderSplitContent
